{
  "Presence_Page_Title": "Presence",
  "Presence_SortBy_Title": "Sort by:",
  "Presence_SortBy_Options_FullName_ASC": "Full Name (A-Z)",
  "Presence_SortBy_Options_FullName_DSC": "Full Name (Z-A)",
  "Presence_Search_Title": "Search",
  "Presence_Filter_Title": "More Filters",
  "Presence_MoreFilters_Title": "Filter by:",
  "Presence_MoreFilters_Options_Department": "Department",
  "Presence_MoreFilters_Options_Queue": "Queue",
  "Presence_Filter_Availability_All": "All",
  "Presence_Filter_Availability_Available": "Available",
  "Presence_Filter_Availability_Busy": "Busy",
  "Presence_Filter_Availability_Away": "Away",
  "Presence_Filter_Availability_Offline": "Offline",
  "Presence_Filter_Availability_OutOfOffice": "Out of Office",
  "Presence_Filter_Availability_DoNotDisturb": "Do Not Disturb",
  "Presence_Filter_Availability_BeRightBack": "Be Right Back",
  "Presence_Activity_Available_Title": "Available",
  "Presence_Activity_Away_Title": "Away",
  "Presence_Activity_BeRightBack_Title": "Be Right Back",
  "Presence_Activity_Busy_Title": "Busy",
  "Presence_Activity_DoNotDisturb_Title": "Do Not Disturb",
  "Presence_Activity_InACall_Title": "In a Call",
  "Presence_Activity_InAConferenceCall_Title": "In a Conference Call",
  "Presence_Activity_Inactive_Title": "Inactive",
  "Presence_Activity_InAMeeting_Title": "In a Meeting",
  "Presence_Activity_Offline_Title": "Offline",
  "Presence_Activity_OffWork_Title": "Off Work",
  "Presence_Activity_OutOfOffice_Title": "Out of Office",
  "Presence_Activity_PresenceUnknown_Title": "Presence Unknown",
  "Presence_Activity_Presenting_Title": "Presenting",
  "Presence_Activity_UrgentInterruptionsOnly_Title": "Urgent Interruptions Only",
  "Presence_NoUsers": "There are no users available for your current filter",
  "Presence_SearchQuery_TooLong": "Search is too long",
  "NAME": "Presence"
}